module.exports = __webpack_public_path__ + "img/nav_icon_reservation.80731c4b.svg";